<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle" style="margin-top: 10px; margin-bottom: 5px">
            <el-breadcrumb-item :to="{ path: '/rolemanagement' }">角色列表</el-breadcrumb-item>
            <el-breadcrumb-item>{{ role_name }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.object_type">
                <vDropdown
                    model_key="object_type"
                    model_name="请选择对象"
                    select_value="value"
                    request_uri="dropdownRoleFields"
                    :model_value_default="queryParams['object_type']"
                    @onDropChange="onDropChange"
                    ref="object_type_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="cant_read"
                    model_name="不可读"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['cant_read']"
                    @onDropChange="onDropChange"
                    ref="cant_read_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="cant_insert"
                    model_name="不可创建"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['cant_insert']"
                    @onDropChange="onDropChange"
                    ref="cant_insert_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="cant_update"
                    model_name="不可编辑"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['cant_update']"
                    @onDropChange="onDropChange"
                    ref="cant_update_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <span style="color: red; font-size: 13px">
                &nbsp;&nbsp;请筛选对象后，进行批量字段权限设置（不可读必定不可创建、不可编辑；不可创建和不可编辑各自独立）<br />
            </span>
            <span style="color: red; font-size: 13px">
                &nbsp;&nbsp;只对当前对象的列表和详情生效（如：下拉列表等不受该配置影响，PS：下拉列表基本只有基础字段，影响不大）<br />
            </span>
            <span style="color: red; font-size: 13px"> &nbsp;&nbsp;注意：对象必填字段被取消相关权限后会导致对象无法保存 <br /> </span>
            &nbsp;&nbsp;<el-button size="small" @click="batchSave" :loading="save_loading">批量保存</el-button>
            <div class="main_header_btns">
                <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="role_field"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['cant_read', 'cant_insert', 'cant_update'])">
                                <el-checkbox v-model="scope.row[item.prop]"></el-checkbox>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    v-show="false"
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[500]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'roleFieldComponent',
    data() {
        return {
            draggable: {
                data_name: 'role_field'
            },
            save_loading: false,
            loading: true,
            role_name: '',
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            productDropData: [],
            formData: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.role_name = this.$route.query.role_name || '';
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {},
        initQueryParams() {
            // 特殊处理下，不重置对象
            var queryParams = JSON.parse(localStorage.getItem('role_field_params'));

            this.queryParams = {
                page: 1,
                row: 500,
                is_export: 0,
                role_rid: this.$route.query.id,
                object_type: (queryParams && queryParams.object_type) || '',
                cant_read: '',
                cant_insert: '',
                cant_update: ''
            };
            this.saveQueryParams();
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            localStorage.setItem('role_field_params', JSON.stringify(this.queryParams));
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            var queryParams = JSON.parse(localStorage.getItem('role_field_params'));
            if (queryParams) {
                this.queryParams = queryParams;
                this.queryParams.role_rid = this.$route.query.id;
            } else {
                this.initQueryParams();
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('role_field', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).role_field;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'roleFieldLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        // 批量保存
        batchSave() {
            this.$confirm('确认批量保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    if (!this.tableData || this.tableData.length == 0) {
                        this.$message.error('当前列表无数据，请调整搜索条件');
                        return false;
                    }
                    this.save_loading = true;
                    var saveData = [];
                    var role_rid = '';
                    this.tableData.forEach((item) => {
                        if (role_rid == '') {
                            role_rid = item.role_rid;
                        }
                        saveData.push({
                            temp_rid: item.temp_rid,
                            cant_read: item.cant_read ? 1 : 2,
                            cant_insert: item.cant_insert ? 1 : 2,
                            cant_update: item.cant_update ? 1 : 2
                        });
                    });

                    this.$api['roleFieldsave']({
                        role_rid: role_rid,
                        data: saveData
                    })
                        .then((res) => {
                            this.save_loading = false;
                            if (res.code == 0) {
                                this.$message.success('保存成功');
                            }
                        })
                        .catch((error) => {
                            this.save_loading = false;
                        });
                })
                .catch(() => {});
        },
        reset() {
            this.initQueryParams();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
</style>